import React, { useEffect, useState } from 'react';

interface AnimatedDotsProps {
  text?: string;
  className?: string;
  dotCount?: number;
  animationSpeed?: number;
}

/**
 * Animated loading dots component
 * Shows text with animated dots: "Logging in..." -> "Logging in.." -> "Logging in..." etc.
 */
export function AnimatedDots({
  text = 'Loading',
  className = '',
  dotCount = 3,
  animationSpeed = 500,
}: AnimatedDotsProps) {
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        const currentDotCount = prev.length;
        if (currentDotCount >= dotCount) {
          return '.';
        }
        return prev + '.';
      });
    }, animationSpeed);

    return () => clearInterval(interval);
  }, [animationSpeed, dotCount]);

  return (
    <span className={className}>
      {text}
      <span className="inline-block w-4 text-left">{dots}</span>
    </span>
  );
}


